(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_ba0dab7"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chroma-daddy-hero')) {
    class ChromaDaddyHero extends HTMLElement {
      constructor() {
        super();

        this.model = null;
        this.animationFrame = null;
        this.startTime = null;

        this.mobileQuery =
          window.matchMedia('(max-width: 749px)');

        this.reduceMotion =
          window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleViewportChange =
          this.handleViewportChange.bind(this);
      }

      connectedCallback() {
        this.model = this.querySelector('model-viewer');
        if (!this.model) return;

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener(
            'change',
            this.handleViewportChange
          );
        } else {
          this.mobileQuery.addListener(
            this.handleViewportChange
          );
        }

        this.startAnimation();
      }

      disconnectedCallback() {
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
        }

        if (this.mobileQuery.removeEventListener) {
          this.mobileQuery.removeEventListener(
            'change',
            this.handleViewportChange
          );
        } else {
          this.mobileQuery.removeListener(
            this.handleViewportChange
          );
        }
      }

      number(name) {
        return Number(this.dataset[name] || 0);
      }

      getCameraDistance() {
        return this.mobileQuery.matches
          ? this.number('mobileDistance')
          : this.number('desktopDistance');
      }

      getBasePitch() {
        return this.mobileQuery.matches
          ? this.number('mobilePitch')
          : this.number('desktopPitch');
      }

      getBaseReflection() {
        return this.mobileQuery.matches
          ? this.number('mobileReflection')
          : this.number('desktopReflection');
      }

      getLightSweep() {
        return this.mobileQuery.matches
          ? this.number('mobileLightSweep')
          : this.number('desktopLightSweep');
      }

      getWobble() {
        return this.mobileQuery.matches
          ? this.number('mobileWobble')
          : this.number('desktopWobble');
      }

      handleViewportChange() {
        this.startTime = null;

        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
        }

        this.startAnimation();
      }

      startAnimation() {
        const animate = (timestamp) => {
          if (!this.model) return;

          if (!this.startTime) {
            this.startTime = timestamp;
          }

          const distance = this.getCameraDistance();
          const basePitch = this.getBasePitch();
          const reflectionBase = this.getBaseReflection();
          const sweepAmount = this.getLightSweep();
          const wobbleAmount = this.getWobble();

          if (this.reduceMotion.matches) {
            this.model.orientation =
              `0deg ${reflectionBase}deg 0deg`;

            this.model.cameraOrbit =
              `0deg ${basePitch}deg ${distance}%`;

            return;
          }

          const elapsed =
            (timestamp - this.startTime) / 1000;

          const lightSpeed =
            this.number('lightSpeed') / 100;

          const wobbleSpeed =
            this.number('wobbleSpeed') / 100;

          /*
            LIGHT SWEEP:
            Move the reflection angle gently so the facets
            keep catching changing highlights.
          */
          const reflectionPitch =
            reflectionBase +
            Math.sin(elapsed * lightSpeed) * sweepAmount;

          this.model.orientation =
            `0deg ${reflectionPitch}deg 0deg`;

          /*
            ORIGINAL-STYLE SUBTLE PARTIAL ROTATE:
            Gentle side-to-side camera wobble with a tiny
            matching pitch shift, like the earlier version.
          */
          const wobbleYaw =
            Math.sin(elapsed * wobbleSpeed) * wobbleAmount;

          const wobblePitch =
            Math.sin(elapsed * wobbleSpeed * 0.65) *
            (wobbleAmount * 0.25);

          this.model.cameraOrbit =
            `${wobbleYaw}deg ${basePitch + wobblePitch}deg ${distance}%`;

          this.animationFrame =
            requestAnimationFrame(animate);
        };

        this.animationFrame =
          requestAnimationFrame(animate);
      }
    }

    customElements.define(
      'chroma-daddy-hero',
      ChromaDaddyHero
    );
  }
  } catch(e) { console.error(e); }
})();

})();
